import React, { useContext, useState } from "react";
import toast from "react-hot-toast";
import SystemModal from "../Common/SystemModal";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices";
import ajaxSupplierInvoicesPayments from "../../util/remote/ajaxSupplierInvoicesPayments";
import AuthContext from "../../Context/AuthContext";
const AddInvoicePartialPayment = (props) => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  // 💾 Submit partial payment
  const submitPartialPayment = async (e, controls) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0) {
      toast.error("Please enter a valid payment amount");
      return;
    }
    setLoading(true);
    const data = {
      InvoiceID: props.invoiceId,
      amount: amount,
      date_created: paymentDate,
      created_by: userId,
    };
    const response = await ajaxSupplierInvoicesPayments.createSupplierPayment(
      data
    );
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message || "Partial payment added successfully");
      props.func();
      controls.close();
    } else {
      toast.error(response.message || "Failed to add payment");
    }
  };
  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button
        className="btn ripple btn-primary"
        type="button"
        disabled={loading}
        onClick={(e) => submitPartialPayment(e, controls)}
      >
        {loading ? "Saving..." : "Save Payment"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Add Partial Payment"
      id="modal-add-partial-payment"
      size="md"
      footer={RenderFooter}
    >
      <form>
        {/* Amount Field */}
        <div className="mb-3">
          <label className="form-label">Amount Paid</label>
          <input
            type="number"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
          />
        </div>
        {/* Optional: Payment Date */}
        <div className="mb-3">
          <label className="form-label">Payment Date</label>
          <input
            type="date"
            className="form-control"
            value={paymentDate}
            onChange={(e) => setPaymentDate(e.target.value)}
          />
        </div>
      </form>
    </SystemModal>
  );
};
export default AddInvoicePartialPayment;
